import React, { useContext } from 'react';
import { Button } from './ui/Button';
import { NavigationContext, CartContext } from '../App';
// Product images from Christiana's collection
const IMAGES = {
  blackPeplum: 'https://cdn.magicpatterns.com/uploads/k3nbovxYYDH3962AQgD28u/photo_2026-02-04_04-57-03.jpg',
  brownPleated: 'https://cdn.magicpatterns.com/uploads/dyohvQLDScUhskTJ884wYi/photo_2026-02-04_04-57-01.jpg',
  purpleFringe: 'https://cdn.magicpatterns.com/uploads/rrAJzJnT1RaD9iNVi3fG4e/photo_2026-02-04_04-57-00.jpg',
  tealSuit: 'https://cdn.magicpatterns.com/uploads/3hrnMEGcTHukVuERpb86Hi/photo_2026-02-04_04-57-05.jpg',
  greenMaxi: 'https://cdn.magicpatterns.com/uploads/n3jybvjJ42ADZp6V5BmhiN/photo_2026-02-04_04-57-04.jpg',
  goldPleated: 'https://cdn.magicpatterns.com/uploads/ksWTzFirUa358KYJesShzR/photo_2026-02-04_04-56-59.jpg',
  blackEmbroidered: 'https://cdn.magicpatterns.com/uploads/8Pmu6fAwDDrQ92G1L4HjJg/photo_2026-02-04_04-56-58.jpg',
  emeraldSuit: 'https://cdn.magicpatterns.com/uploads/wYFN1VGG9zCp3b6QMLCMkr/photo_2026-02-04_04-56-56.jpg'
};
const products = [{
  id: 1,
  name: 'Black Peplum & Sequin Skirt Set',
  price: 185.0,
  priceDisplay: '$185.00',
  image: IMAGES.blackPeplum
}, {
  id: 2,
  name: 'Gold Puff Sleeve Pleated Gown',
  price: 225.0,
  priceDisplay: '$225.00',
  image: IMAGES.goldPleated
}, {
  id: 3,
  name: 'Black & Gold Embroidered Kaftan',
  price: 245.0,
  priceDisplay: '$245.00',
  image: IMAGES.blackEmbroidered
}, {
  id: 4,
  name: 'Emerald Crystal Belted Suit',
  price: 195.0,
  priceDisplay: '$195.00',
  image: IMAGES.emeraldSuit
}];
export function FeaturedProducts() {
  const {
    navigate
  } = useContext(NavigationContext);
  const {
    addToCart
  } = useContext(CartContext);
  const handleAddToCart = (product: (typeof products)[0]) => {
    addToCart({
      id: product.id,
      name: product.name,
      price: product.price,
      size: 'M',
      color: 'Default',
      quantity: 1,
      image: product.image
    });
  };
  return <section className="py-24 bg-white relative" data-id="element-94">
      {/* Kente stripe accent */}
      <div className="absolute top-0 left-0 right-0 h-1.5 kente-stripe" data-id="element-95" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-96">
        <div className="text-center mb-16" data-id="element-97">
          <p className="text-sm sm:text-base uppercase tracking-[0.2em] text-[#6B5B4F] mb-3" data-id="element-98">
            Handpicked for You
          </p>
          <h2 className="text-4xl sm:text-5xl md:text-6xl font-['Playfair_Display'] text-[#5C3D2E]" data-id="element-99">
            Curated Favorites
          </h2>
          <div className="w-14 h-[2px] bg-[#D4A853] mx-auto mt-5" data-id="element-100" />
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-4 gap-y-10 md:gap-x-6 lg:gap-x-8" data-id="element-101">
          {products.map(product => <div key={product.id} className="group" data-id="element-102">
              <div onClick={() => navigate('product')} className="w-full aspect-[3/4] mb-5 relative overflow-hidden cursor-pointer bg-[#F5E6D3]" data-id="element-103">
                <img src={product.image} alt={product.name} className="w-full h-full object-cover object-top transition-transform duration-700 ease-out group-hover:scale-105" data-id="element-104" />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-300" data-id="element-105" />

                <div className="absolute bottom-0 left-0 w-full p-3 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" onClick={e => e.stopPropagation()} data-id="element-106">
                  <Button className="w-full bg-[#5C3D2E] text-white hover:bg-[#D4A853] hover:text-[#1A1A1A]" size="sm" onClick={() => handleAddToCart(product)} data-id="element-107">
                    Add to Cart
                  </Button>
                </div>

                {/* Decorative corner */}
                <div className="absolute top-3 right-3 w-8 h-8 border-t border-r border-[#D4A853]/50 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-108" />
              </div>

              <div className="space-y-2" data-id="element-109">
                <h3 onClick={() => navigate('product')} className="text-lg lg:text-xl font-['Playfair_Display'] text-[#5C3D2E] group-hover:text-[#D4A853] transition-colors cursor-pointer leading-snug" data-id="element-110">
                  {product.name}
                </h3>
                <p className="text-lg text-[#6B5B4F] font-['Raleway'] font-medium" data-id="element-111">
                  {product.priceDisplay}
                </p>
              </div>
            </div>)}
        </div>

        <div className="mt-16 text-center" data-id="element-112">
          <Button variant="outline" className="min-w-[200px] h-14 text-base border-[#5C3D2E] text-[#5C3D2E] hover:bg-[#5C3D2E] hover:text-white" onClick={() => navigate('shop')} data-id="element-113">
            View All
          </Button>
        </div>
      </div>
    </section>;
}